import React from 'react';

import Layout from '../components/Layout';
import PageFooter from '../components/PageFooter';
import SideBar from '../components/Sidebar';
import Scroll from '../components/Scroll';

const pic = require('../assets/images/profile_pic.png');

const sections = [
	{ id: 'top', name: 'Intro', icon: 'fa-home' },
	{ id: 'about', name: 'About Me', icon: 'fa-user' },
	{ id: 'community-impact', name: 'Community Impact', icon: 'fa-bullhorn' },
	{ id: 'resume', name: 'CV / Resume', icon: 'fa-list-alt' },
	{ id: 'contact', name: 'Get in Touch', icon: 'fa-envelope' },
];

const IndexPage = () => (
	<Layout>
		<SideBar sections={sections} />

		<div id="main">
			<section id="top" className="one dark cover">
				<div className="container">
					<header>
						<h2 className="alt">
							Hi 👋 I'm <strong>Naman</strong> - a Front-End Engineer from Jaipur, India.
						</h2>
						<p>♥ building accessible, performant and responsive applications - using the Web stack.</p>
					</header>

					<footer>
						<Scroll type="id" element={'about'}>
							<a href="#about" className="button">
								Tell me more ⬇
							</a>
						</Scroll>
					</footer>
				</div>
			</section>

			<section id="about" className="two">
				<div className="container">
					<header>
						<h2>About Me</h2>
					</header>

					<a href="/#" className="image featured" aria-label="Featured image">
						<img src={pic} alt="" />
					</a>

					<p><strong>Sr. Software Engineer (Web)</strong> at Roku | prev at AWS (San Francisco Bay area).
					</p>

					<p>Avid contributor to the developer community - talks | blogs | workshops / codelabs ...
					</p>

					<p>Medium-distance (15K) <a target="_blank"
						rel="noopener noreferrer" href="https://www.strava.com/athletes/72659537">runner</a> | Football (<a target="_blank"
						rel="noopener noreferrer" href="https://www.chelseafc.com/">Chelsea</a>) fan + player | <a target="_blank"
						rel="noopener noreferrer" href="https://www.goodreads.com/user/show/48843112-naman-sancheti">Book lover</a>
					</p>

					<footer>
						<Scroll type="id" element={'community-impact'}>
							<a href="#community-impact" className="button">
								How I contribute ⬇
							</a>
						</Scroll>
					</footer>
				</div>
			</section>

			<section id="community-impact" className="three dark cover community-impact">
				<div className="container">
					<header>
						<h2 className="community-impact__title">Community Impact</h2>

						<h3>Talks / Podcasts</h3>
						<ul className="community-impact__list">
							<li>
								<div className="community-impact__item-title">How to stay relevant as a Developer in the AI Era</div>
								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://www.youtube.com/playlist?list=PLIJrr73KDmRzfkPe_Cr5fLnu2iLiNQtxK"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>Tapas Adhikary's podcast</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/watch?v=FrysN0Ik7vU"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>
							</li>
							
							<li>
								<div className="community-impact__item-title">Building best-in-class apps, faster using Browser DevTools and it's super-powers!</div>
								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://india.cityjsconf.org/"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>CityJS Delhi, 2026</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/watch?v=GpGeHiRro4Y"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>
								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://upfront91.makemytrip.com/"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>Upfront91, 2025</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/live/rn4fUoPmZiQ?si=CgIEj8XsMphWJYMg&t=2417"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>
								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://www.reactindia.io/"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>React India, 2025</a>
									<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/watch?v=deamxXX0ivY"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>
							</li>
							<li>
								<div className="community-impact__item-title">Contributing to Cloudscape (AWS' design system)</div>
								<div>AWS - C3 (Console Community conference), '24 at Seattle</div>
								<a
									href="https://cloudscape.design/"
									target="_blank"
									rel="noopener noreferrer">Cloudscape</a>
							</li>
							<li>
								<div className="community-impact__item-title">WebAssembly: Re-defining capabilities of the Web</div>
								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://2021.reactday.in/"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>ReactDay Bangalore, 2021</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://youtu.be/HWx6nkLE5Po?t=8348"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>

							</li>
							<li>
								<div className="community-impact__item-title">Developing Accessible Applications</div>
								<div
								style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://www.recro.io/"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>Recro</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://youtu.be/SwhqebijUlk"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>
							</li>
							<li>
								<div className="community-impact__item-title">Building VS Code Extensions</div>
								<div>ReactJS Bangalore Meetup</div>
								<a
									href="https://docs.google.com/presentation/d/1zdEa31QBqlU3XoTvnjk5eJPURwqRBez_WrwrxWzRtwg/view#slide=id.p"
									target="_blank"
									rel="noopener noreferrer">Slides</a>
								<br />
								<a
									href="https://www.meetup.com/ReactJS-Bangalore/events/260222287/"
									target="_blank"
									rel="noopener noreferrer">Meetup</a>
							</li>
							<li>
								<div className="community-impact__item-title">Building Web Components using Angular Elements</div>
								<div
								style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://www.meetup.com/angular-bangalore-group/events/263773017/"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>Angular Bangalore Meetup</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/watch?v=sHH3fxyU5mU"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>
							</li>
							<li>
								<div className="community-impact__item-title">Modern JavaScript (ES6)</div>
								<div>TechClub - Morgan Stanley</div>
								<a
									href="https://docs.google.com/presentation/d/1i-BPKzBHLPTkY0DfkTZPSqIpoHGyGozCfomKk8wWiUY/view#slide=id.p"
									target="_blank"
									rel="noopener noreferrer">Slides</a>
							</li>
							<li>
								<div className="community-impact__item-title">LintStudio: GUI for creating custom ESLint plugins</div>
								<div>Amazon - WebDevCon '20 (remote)</div>
							</li>
						</ul>

						<h3>Workshops / Codelabs</h3>
						<ul className="community-impact__list">
							<li>
								<div className="community-impact__item-title">Building VS Code Extensions</div>
								<div>JSLovers Bangalore Meetup</div>
								<a
									href="https://github.com/namansancheti/rxjs-buddy"
									target="_blank"
									rel="noopener noreferrer">Codelab</a>
								<br />
								<a
									href="https://www.meetup.com/jslovers-bengaluru/events/262275286/"
									target="_blank"
									rel="noopener noreferrer">Meetup</a>
							</li>
							<li>
								<div className="community-impact__item-title">Trainer - JS and Angular</div>
								<div>Spring Intern training - Morgan Stanley</div>
								<div>Audience - 20+ interns</div>
							</li>
						</ul>

						<h3>Organizing</h3>
						<ul className="community-impact__list">
							<li>
								<div className="community-impact__item-title">Organizing team and Panel moderator</div>

								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://www.reactindia.io/schedule"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>React India, 2026 - Panel (Day 1)</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/live/InL7uyOZZ1s?si=FWItMzaE3IoxNz7K&t=28951"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>

								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://www.reactindia.io/schedule"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>React India, 2026 - Panel (Day 2)</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/live/dK_H_tjr3Qc?si=DtCTX_gXfdzqX1Pg&t=26399"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>										
							</li>
							<li>
								<div className="community-impact__item-title">Organizing team and Panel moderator</div>
								<div
									style={{display: 'flex', alignItems: 'flex-start'}}>
									<a
										href="https://2026.reactnexus.com/"
										target="_blank"
										rel="noopener noreferrer"
										style={{marginRight: '12px'}}
									>React Nexus, 2026</a>
										<a
										class="text-secondary ml-2 flex-none hover:text-team-current"
										href="https://www.youtube.com/watch?v=i_F2xmGMiMQ"
										style={{paddingTop: '4px', textDecoration: 'none', borderBottom: '0'}}
									>
										<svg
											width="31"
											height="32"
											fill="none"
											viewBox="0 0 24 24"
											style={{paddingTop: '0px'}}
										>
											<title>YouTube</title>
											<path
												fill="currentColor"
												d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
											></path>
										</svg>
									</a>
								</div>
							</li>
							<li>
								<div className="community-impact__item-title">Coordinator</div>
								<div>Knuth Programming Hub - JIIT Noida</div>
								<a
									href="http://www.jiit.ac.in/knuth-programming-hub"
									target="_blank"
									rel="noopener noreferrer">Official page</a>
							</li>
							<li>
								<div className="community-impact__item-title">Coordinator - Technical Department</div>
								<div>Google Developers' Group - JIIT Noida </div>
								<a
									href="http://www.jiit.ac.in/gdg"
									target="_blank"
									rel="noopener noreferrer">Official page</a>
							</li>
							<li>
								<div className="community-impact__item-title">Lead organizer</div>
								<div>Giving back event - Samarthanam Trust, Mumbai</div>
								<div>Led team to conduct mock job interviews for 20+ students with disabilities.</div>
								<a
									href="https://www.samarthanam.org/"
									target="_blank"
									rel="noopener noreferrer">Website</a>
							</li>
						</ul>

						<h3 className="community-impact__section-title">Open source</h3>
						<a
							href="https://github.com/namansancheti"
							target="_blank"
							rel="noopener noreferrer">View contributions</a>

						<h3 className="community-impact__section-title">Blogging</h3>
						<a
							href="https://medium.com/@naman.sancheti"
							target="_blank"
							rel="noopener noreferrer">View posts</a>

						<h3 className="community-impact__section-title">Stack Overflow</h3>
						<a
							href="https://stackoverflow.com/users/3709792/naman-sancheti"
							target="_blank"
							rel="noopener noreferrer">View profile</a>
					</header>

					<footer>
						<Scroll type="id" element={'resume'}>
							<a href="#resume" className="button">
								CV / Resume ⬇
							</a>
						</Scroll>
					</footer>
				</div>
			</section>

			<section id="resume" className="four">
				<div className="container">
					<header>
						<h2>CV / Resume</h2>
					</header>

					<a
						href="https://drive.google.com/file/d/1XeM0k91M4iKpeq-ml7yHHhKRw7yAjhoQ/view"
						target="_blank"
						rel="noopener noreferrer"
						className="button scrolly">View CV / Resume
					</a>
				</div>
			</section>

			<section id="contact" className="five dark cover contact">
				<div className="container">
					<header>
						<h2>Get in Touch</h2>
						<p>Want to collaborate ? Got a job opportunity ? Have queries ?</p>
						<p>Please reach out at [naman dot sancheti at gmail dot com].</p>
						<p>I promise to get back very soon! :)</p>
					</header>
				</div>
			</section>
		</div>

		<PageFooter />
	</Layout>
);

export default IndexPage;
